import { HomeSlickComponent } from "front-end/components/homeslick.component";
import { TeamMembersProfileModel } from "./models/team-members-profile.model";
import { TeamMembersProfileModalComponent } from "./team-members-profile-modal.component";
import { TeamMembersProfileComponent } from "./team-members-profile.component";

export class TeamMembersProfilesService {
    private _currentContext: JQuery = $();

    private _teamMembersProfileComponents: Array<TeamMembersProfileComponent> = [];
    private _teamMembersProfileModels: Array<TeamMembersProfileModel> = [];

    private _teamMembersProfileModalComponent: TeamMembersProfileModalComponent = null;

    private _slider: HomeSlickComponent = null;

    private _moduleOptions = {
        mobileFirst: true,
        dots: true,
        arrows: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: "unslick"
            }
        ]
    };

    private bindEvents(): void {
        this._teamMembersProfileComponents.forEach(profile => {
            profile.on("profile/click")
                .subscribe((profileId: number) => {
                    const profileModel = this._teamMembersProfileModels.find((p: TeamMembersProfileModel) => p.id === profileId);
                    if (profileModel) {
                        this._teamMembersProfileModalComponent.setProfile(profileModel).render().show();
                    }
                });
        });
    }

    private parseContext(): void {
        const sliderContext = $(".js-ina-people-slider", this._currentContext);
        const slider = new HomeSlickComponent();
        slider.init(sliderContext, this._moduleOptions);
        this._slider = slider;

        const teamMembersProfilesContext = $(TeamMembersProfileComponent.SELECTOR, this._currentContext);
        teamMembersProfilesContext.each((index, entry) => {
            const profileContext = $(entry);
            const profileComponent = new TeamMembersProfileComponent();
            profileComponent.init(profileContext);
            this._teamMembersProfileComponents.push(profileComponent);
        });

        const modal = $(TeamMembersProfileModalComponent.SELECTOR, this._currentContext);
        this._teamMembersProfileModalComponent = new TeamMembersProfileModalComponent();
        this._teamMembersProfileModalComponent.init(modal);
    }

    public init(context: JQuery, teamMembersProfileModels: Array<TeamMembersProfileModel>): void {
        this._currentContext = context || this._currentContext;

        this._teamMembersProfileModels = teamMembersProfileModels;

        this.parseContext();
        this.bindEvents();
    }
}
